import React, { forwardRef } from 'react';
import { useField } from 'formik';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const TextInput = ({ className = '', label, type = 'text', ...props }, ref) => {
  const [field] = useField(props);

  return (
    <div className={className}>
      <label>{label}</label>
      <input type={type} ref={ref} {...field} {...props} />
    </div>
  );
};

export default forwardRef(TextInput);

export const PasswordInput = forwardRef(({ className = '', label, ...props }, ref) => {
  const [field, meta] = useField(props);
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className={className}>
      <label>{label}</label>
      <div className='password-input-wrapper'>
        <input
          type={showPassword ? 'text' : 'password'}
          ref={ref}
          {...field}
          {...props}
        />
        <button
          type='button'
          className='password-toggle'
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          onClick={() => setShowPassword((s) => !s)}>
          {showPassword ? <VisibilityOff sx={{ fontSize: 18 }} /> : <Visibility sx={{ fontSize: 18 }} />}
        </button>
      </div>
      {meta.touched && meta.error ? <p className='form-error'>{meta.error}</p> : null}
    </div>
  );
});
